/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Button, Heading, Input, Stack, Text } from "components/index";
import { ChangeEvent, useState } from "react";
import { useUI } from "state/UIContext";
import { useTranslation } from "react-i18next";
import { pushToDataLayer } from "utils/gtm";

const FeedbackModal = ({ handleFeedback }: { handleFeedback: Function }) => {
  const { t } = useTranslation();
  const [feedback, setFeedback] = useState("");
  const { closeModal } = useUI();
  return (
    <div className="max-w-[430px] p-10 -bg--theme-colors-surface-neutral-level04  border -border--theme-colors-border-neutral-07">
      <Stack className="gap-y-4">
        <Heading className="text-2xl -text--theme-colors-text-title" as="h2">
          {t("feedbackModal.errorMSG")}
        </Heading>

        <Text className="-text--theme-colors-text-body">
          {t("feedbackModal.shareAvailabilityMSG")}
        </Text>
        <Input
          type="textarea"
          placeholder={t("guestInfoPage.detailsPlaceholder")}
          value={feedback}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setFeedback(e.target.value)
          }
          rows={5}
        />
        <div className="flex gap-x-2.5">
          <Button
            size="lg"
            variant="secondary"
            onClick={() => {
              pushToDataLayer({
                event: "attendance_decline_skip",
                screen_name: "attendance decline",
                journey_step: "attendance",
              });
              closeModal();
            }}
            className="mt-4"
            fullWidth
          >
            {t("common.buttons.cancel")}
          </Button>
          <Button
            size="lg"
            variant="primary"
            onClick={() => {
              pushToDataLayer({
                event: "attendance_decline_submit",
                screen_name: "attendance decline",
                journey_step: "attendance",
              });
              handleFeedback(feedback);
            }}
            className="mt-4"
            fullWidth
          >
            {t("common.buttons.submit")}
          </Button>
        </div>
      </Stack>
    </div>
  );
};

export default FeedbackModal;
